export const EXCEECEDS_BALANCE_LIMIT = 'exceedsBalanceLimit.th';
export const CARD_RELOAD_ERROR = 'reloadCardError';
